import React from "react";
import { ButtonMain } from "components";
import { Svg } from "assets";

export const CharityCreated = ({ toggleShowing }) => {
  return (
    <div className="in-memory-of-box">
      <div className="in-memory-of-content">
        <div className="container">
          <div className="in-memory-form-wrapper see-your-event-memory-wrapper charity-created-memory-wrapper">
            <Svg.PaperPlaneMemorySvg />
            <div className="see-your-event-title_desc">
              <p className="see-your-event-title">
                Your charity have been sent for review!
              </p>
              <p
                className="see-your-event-desc"
                style={{ fontWeight: 700, marginBottom: "4px" }}
              >
                The Process may take up to two weeks.
              </p>
              <p className="see-your-event-desc">
                If you prefer not to wait, you can Go back and choose a charity
                from the list that provides our system.
              </p>
            </div>

            <div className="charity-created-buttons_block">
              <ButtonMain
                classNameWrapper="memory-button"
                text={"Done"}
                type="button"
                onClick={() =>
                  toggleShowing((prev) => ({
                    ...prev,
                    showCharityDetails: false,
                    successCratingEvent: false,
                    successCratingCharity: false,
                  }))
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
